<div class="modal-header">
  <mat-icon class="icon-close" (click)="close()"></mat-icon>
</div>
<div class="modal-wrapper">
  <img *ngIf="data.success" class="result-modal-icon" src="assets/icons/success.svg" />
  <img *ngIf="!data.success" class="result-modal-icon" src="assets/icons/failed.svg" />
  <div class="result-modal-message" [ngClass]="{'failed': !data.success}">{{data.message | resolve}}</div>
  <div class="button-wrapper center">
    <button mat-flat-button color="primary" (click)="close()">
      {{'mkb.card3dsecure.modal.result.ok.button.title' | resolve}}
    </button>
  </div>
</div>
